/* import __COLOCATED_TEMPLATE__ from './google-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./google-icon.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());